export type CreditNoteItemModel = {
  cache_key: number,
  credit_note_id: number,
  description?: string,
  id: number,
  price?: number,
  quantity: number,
}

export type CreditNoteItemRequestOptions = {}

const state = {
  credit_note_id: null,
  description: '',
  id: null,
  price: 0,
  quantity: 1,
}

export const requiredFields = [
  { key: 'description' },
  { key: 'price' },
]

export default state
